import * as tablesActions from './actions';
import * as menuActions from '../menu/actions';
import * as categoriesActions from '../categories/actions';
import {Record} from '../transit';

const State = Record({
    tablesVisible: false,
    defaultTablesVisible: false,
    newTableVisible: false,
    tableDivideVisible: false,
    newTableUuid: null
}, 'tables');

const TABLES_VISIBLE = 'tablesVisible';
const DEFAULT_TABLES_VISIBLE = 'defaultTablesVisible';
const TABLE_DIVIDE_VISIBLE = 'tableDivideVisible';
const NEW_TABLE_VISIBLE = 'newTableVisible';
const NEW_TABLE_UUID = 'newTableUuid';

const tablesReducer = (state = new State(), action) => {

    switch (action.type) {

        case tablesActions.DELETE_TABLE: {
            return goToHome(state);
        }

        case tablesActions.OPEN_TABLE: {
            const {toHomepage} = action.payload;
            const newState = state
                .set(NEW_TABLE_UUID, null)
                .set(NEW_TABLE_VISIBLE, false)
                .set(TABLE_DIVIDE_VISIBLE, false);

            if (toHomepage) {
                return goToHome(newState);
            } else {
                return newState.set(TABLES_VISIBLE, false);
            }
        }

        case tablesActions.ADD_TO_TABLE: {
            return state
                .set(NEW_TABLE_UUID, null)
                .set(NEW_TABLE_VISIBLE, false)
                .set(TABLE_DIVIDE_VISIBLE, false)
                .set(TABLES_VISIBLE, false);
        }

        case tablesActions.CLOSE_SHOW_TABLE:
        case menuActions.CLOSE_MENU:
        case tablesActions.TABLE_SAVE:
        case tablesActions.GO_HOMEPAGE:
        case categoriesActions.PAY_ORDER_START: {
            const newState = state
                .set(NEW_TABLE_UUID, null)
                .set(NEW_TABLE_VISIBLE, false)
                .set(TABLE_DIVIDE_VISIBLE, false);

            return goToHome(newState);
        }

        case tablesActions.SET_DEFAULT_TABLE_VISIBLE: {
            return state.set(DEFAULT_TABLES_VISIBLE, action.payload);
        }

        case tablesActions.SHOW_TABLE: {
            return state
                .set(NEW_TABLE_UUID, null)
                .set(NEW_TABLE_VISIBLE, false)
                .set(TABLE_DIVIDE_VISIBLE, false)
                .set(TABLES_VISIBLE, false);
        }

        case tablesActions.OPEN_DIVIDE_TABLE: {
            return state.set(TABLE_DIVIDE_VISIBLE, true);
        }

        case tablesActions.CLOSE_DIVIDE_TABLE: {
            const newState = state.set(TABLE_DIVIDE_VISIBLE, false);
            return goToHome(newState);
        }

        case tablesActions.OPEN_TABLES: {
            return state.set(TABLES_VISIBLE, true);
        }

        case tablesActions.CLOSE_TABLES: {
            return state.set(TABLES_VISIBLE, false);
        }

        case tablesActions.OPEN_NEW_TABLE: {
            return state
                .set(NEW_TABLE_UUID, action.payload)
                .set(NEW_TABLE_VISIBLE, true);
        }

        case tablesActions.CLOSE_NEW_TABLE: {
            return state
                .set(NEW_TABLE_UUID, null)
                .set(NEW_TABLE_VISIBLE, false);
        }

    }

    return state;
};

function goToHome(state) {
    return state
        .set(TABLES_VISIBLE, state.get(DEFAULT_TABLES_VISIBLE));
}

export default tablesReducer;



// WEBPACK FOOTER //
// ./src/common/tables/reducer.js